import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import {
  ContainerHeader,
  StageDataTable,
  FormStageModal
} from "@/components/common";
import { Button } from "@/components/ui/button";
import { EmptyState, PageHeader } from "@/components/ui";
import { Input } from "@/components/ui/input";
import { useFetchStagesQuery } from "@/hooks";
import { Skeleton } from "@/components/ui/skeleton";

export function Stages() {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const [search, setSearch] = useState<string>("");

  const {
    data: stagesData,
    refetch: refetchStagesData,
    isLoading,
  } = useFetchStagesQuery({ page, search });

  const handleDelete = () => {
    refetchStagesData();
  };

  useEffect(() => {
    setTimeout(async () => {
      await refetchStagesData();
    }, 1500);
  }, [page, search]);

  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow="Crescimento"
          title="Etapas do funil"
          lede="As etapas por onde uma oportunidade passa até virar paciente."
          actions={
            <FormStageModal>
              <Button variant="petrol" size="lg" className="px-5">
                {t("LABEL.new")}
              </Button>
            </FormStageModal>
          }
        />
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar etapas do funil"
            placeholder="Pesquisar etapas..."
            showError={false}
            className="max-w-md"
          />
        </ContainerHeader>
      </div>
      <div className="space-y-2">
        {!stagesData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : stagesData.items.length === 0 ? (
          <EmptyState
            title="Nenhuma etapa cadastrada"
            description="As etapas descrevem o caminho de uma oportunidade no funil. Crie a primeira para começar."
            action={
              <FormStageModal>
                <Button variant="outline">{t("LABEL.new")}</Button>
              </FormStageModal>
            }
          />
        ) : (
          <StageDataTable
            data={stagesData?.items || []}
            paginationData={stagesData?.data}
            onDelete={handleDelete}
          />
        )}
      </div>
    </section>
  );
}